<ng-template #contentHeaderTemplate></ng-template>

<app-table
  id="dashboard.administration.patients-login.index"
  [showEditLink]="false"
></app-table>
